import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexte/AuthContexte';
import { usePanier } from '../contexte/PanierContexte';

export default function BarreNavigation() {
  const navigate = useNavigate();
  const { estConnecte, estAdmin, utilisateur, deconnexion } = useAuth();
  const { nbArticles } = usePanier();
  const [q, setQ] = useState('');
  const [menuOuvert, setMenuOuvert] = useState(false);

  function soumettre(e) {
    e.preventDefault();
    navigate(`/?recherche=${encodeURIComponent(q)}`);
    setMenuOuvert(false);
  }

  return (
    <header className="sticky top-0 z-50 bg-white/95 shadow-md backdrop-blur">
      <div className="mx-auto w-full max-w-7xl px-4 py-3">
        <div className="flex items-center justify-between gap-3">
          <Link to="/" className="group flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-gradient-to-br from-orange-500 to-orange-600 shadow-lg">
              <span className="text-xl font-bold text-white">M</span>
            </div>
            <div className="leading-tight">
              <div className="text-lg font-bold tracking-tight text-gray-900">MaBoutique</div>
              <div className="text-[11px] text-gray-600">Shopping moderne</div>
            </div>
          </Link>

          <div className="hidden flex-1 md:block">
            <form onSubmit={soumettre} className="w-full">
              <div className="flex items-center overflow-hidden rounded-2xl border border-gray-200 bg-gray-50">
                <input
                  value={q}
                  onChange={(e) => setQ(e.target.value)}
                  placeholder="Rechercher un produit..."
                  className="w-full bg-transparent px-4 py-2.5 text-sm text-gray-900 placeholder:text-gray-500 focus:outline-none"
                />
                <button
                  type="submit"
                  className="px-4 py-2.5 text-sm font-semibold text-gray-600 hover:text-gray-900"
                >
                  🔍
                </button>
              </div>
            </form>
          </div>

          <div className="flex items-center gap-2 md:hidden">
            <Link
              to="/panier"
              className="relative flex h-10 w-10 items-center justify-center rounded-xl border border-gray-200 bg-white"
            >
              🛒
              {nbArticles > 0 ? (
                <span className="absolute -right-1 -top-1 grid h-5 w-5 place-items-center rounded-full bg-orange-500 text-[11px] font-bold text-white">
                  {nbArticles}
                </span>
              ) : null}
            </Link>
            <button
              onClick={() => setMenuOuvert((v) => !v)}
              className="flex h-10 w-10 items-center justify-center rounded-xl border border-gray-200 bg-white text-gray-900"
            >
              {menuOuvert ? '✕' : '☰'}
            </button>
          </div>

          <nav className="ml-auto hidden items-center gap-3 md:flex">
            <Link
              to="/panier"
              className="relative rounded-2xl border border-gray-200 bg-white px-4 py-2 text-sm font-semibold text-gray-900 hover:bg-gray-50"
            >
              🛒 Panier
              {nbArticles > 0 ? (
                <span className="absolute -right-2 -top-2 grid h-5 w-5 place-items-center rounded-full bg-orange-500 text-[11px] font-bold text-white">
                  {nbArticles}
                </span>
              ) : null}
            </Link>

            {estConnecte ? (
              <div className="flex items-center gap-2 text-sm">
                <Link to="/mes-commandes" className="rounded-2xl px-3 py-2 text-gray-600 hover:text-gray-900">
                  📦 Mes commandes
                </Link>
                {estAdmin ? (
                  <Link to="/admin" className="rounded-2xl px-3 py-2 text-gray-600 hover:text-gray-900">
                    ⚙️ Admin
                  </Link>
                ) : null}
                <button
                  onClick={deconnexion}
                  className="rounded-2xl border border-gray-200 bg-white px-3 py-2 text-gray-900 hover:bg-gray-50"
                >
                  👤 {utilisateur?.nom || 'Compte'}
                </button>
              </div>
            ) : (
              <div className="flex items-center gap-2 text-sm">
                <Link to="/connexion" className="rounded-2xl px-3 py-2 text-gray-600 hover:text-gray-900">
                  Connexion
                </Link>
                <Link
                  to="/inscription"
                  className="rounded-2xl bg-orange-500 px-4 py-2 font-semibold text-white shadow-lg hover:bg-orange-600"
                >
                  S'inscrire
                </Link>
              </div>
            )}
          </nav>
        </div>

        {menuOuvert ? (
          <div className="mt-3 grid gap-3 rounded-2xl border border-gray-200 bg-white p-4 text-sm md:hidden">
            <form onSubmit={soumettre}>
              <div className="flex items-center overflow-hidden rounded-2xl border border-gray-200 bg-gray-50">
                <input
                  value={q}
                  onChange={(e) => setQ(e.target.value)}
                  placeholder="Rechercher un produit..."
                  className="w-full bg-transparent px-3 py-2 text-gray-900 placeholder:text-gray-500 focus:outline-none"
                />
                <button type="submit" className="px-3 py-2 text-gray-600">
                  🔍
                </button>
              </div>
            </form>

            <Link
              to="/mes-commandes"
              className="rounded-2xl px-3 py-2 text-gray-600 hover:bg-gray-50"
              onClick={() => setMenuOuvert(false)}
            >
              📦 Mes commandes
            </Link>
            {estAdmin ? (
              <Link
                to="/admin"
                className="rounded-2xl px-3 py-2 text-gray-600 hover:bg-gray-50"
                onClick={() => setMenuOuvert(false)}
              >
                ⚙️ Admin
              </Link>
            ) : null}

            {estConnecte ? (
              <button
                onClick={() => {
                  deconnexion();
                  setMenuOuvert(false);
                }}
                className="rounded-2xl border border-gray-200 bg-white px-3 py-2 text-gray-900 hover:bg-gray-50"
              >
                👤 {utilisateur?.nom || 'Compte'}
              </button>
            ) : (
              <div className="grid gap-2">
                <Link
                  to="/connexion"
                  className="rounded-2xl border border-gray-200 px-3 py-2 text-center text-gray-900 hover:bg-gray-50"
                  onClick={() => setMenuOuvert(false)}
                >
                  Connexion
                </Link>
                <Link
                  to="/inscription"
                  className="rounded-2xl bg-orange-500 px-3 py-2 text-center font-semibold text-white hover:bg-orange-600"
                  onClick={() => setMenuOuvert(false)}
                >
                  S'inscrire
                </Link>
              </div>
            )}
          </div>
        ) : null}
      </div>
    </header>
  );
}
